/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import UserBase from './UserBase';

/**
 * The UserResponse model module.
 * @module model/UserResponse
 * @version 1.1.0
 */
class UserResponse {
    /**
     * Constructs a new <code>UserResponse</code>.
     * User response with all fields including read-only server-managed fields
     * @alias module:model/UserResponse
     * @implements module:model/UserBase
     * @param firstName {String} 
     * @param lastName {String} 
     * @param email {String} 
     * @param phoneNumber {String} 
     * @param address {module:model/Address} 
     * @param isAdmin {Boolean} 
     * @param enabled {Boolean} 
     * @param notes {String} 
     * @param userId {String} 
     * @param emailVerified {Boolean} 
     * @param timeCreated {Date} 
     * @param timeLastUpdated {Date} 
     * @param lastLogin {Date} 
     */
    constructor(firstName, lastName, email, phoneNumber, address, isAdmin, enabled, notes, userId, emailVerified, timeCreated, timeLastUpdated, lastLogin) { 
        UserBase.initialize(this);
        UserResponse.initialize(this, firstName, lastName, email, phoneNumber, address, isAdmin, enabled, notes, userId, emailVerified, timeCreated, timeLastUpdated, lastLogin);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, firstName, lastName, email, phoneNumber, address, isAdmin, enabled, notes, userId, emailVerified, timeCreated, timeLastUpdated, lastLogin) { 
        obj['firstName'] = firstName;
        obj['lastName'] = lastName;
        obj['email'] = email;
        obj['phoneNumber'] = phoneNumber;
        obj['address'] = address;
        obj['isAdmin'] = isAdmin;
        obj['enabled'] = enabled;
        obj['notes'] = notes;
        obj['userId'] = userId;
        obj['emailVerified'] = emailVerified;
        obj['timeCreated'] = timeCreated;
        obj['timeLastUpdated'] = timeLastUpdated;
        obj['lastLogin'] = lastLogin;
    }

    /**
     * Constructs a <code>UserResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserResponse} obj Optional instance to populate.
     * @return {module:model/UserResponse} The populated <code>UserResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserResponse();
            UserBase.constructFromObject(data, obj);

            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phoneNumber')) {
                obj['phoneNumber'] = ApiClient.convertToType(data['phoneNumber'], 'String');
            }
            if (data.hasOwnProperty('fireDeptId')) {
                obj['fireDeptId'] = ApiClient.convertToType(data['fireDeptId'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
            if (data.hasOwnProperty('isAdmin')) {
                obj['isAdmin'] = ApiClient.convertToType(data['isAdmin'], 'Boolean');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('notes')) {
                obj['notes'] = ApiClient.convertToType(data['notes'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
            }
            if (data.hasOwnProperty('emailVerified')) {
                obj['emailVerified'] = ApiClient.convertToType(data['emailVerified'], 'Boolean');
            }
            if (data.hasOwnProperty('timeCreated')) {
                obj['timeCreated'] = ApiClient.convertToType(data['timeCreated'], 'Date');
            }
            if (data.hasOwnProperty('timeLastUpdated')) {
                obj['timeLastUpdated'] = ApiClient.convertToType(data['timeLastUpdated'], 'Date');
            }
            if (data.hasOwnProperty('lastLogin')) {
                obj['lastLogin'] = ApiClient.convertToType(data['lastLogin'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UserResponse.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
            throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
        }
        // ensure the json data is a string
        if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
            throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['phoneNumber'] && !(typeof data['phoneNumber'] === 'string' || data['phoneNumber'] instanceof String)) {
            throw new Error("Expected the field `phoneNumber` to be a primitive type in the JSON string but got " + data['phoneNumber']);
        }
        // ensure the json data is a string
        if (data['fireDeptId'] && !(typeof data['fireDeptId'] === 'string' || data['fireDeptId'] instanceof String)) {
            throw new Error("Expected the field `fireDeptId` to be a primitive type in the JSON string but got " + data['fireDeptId']);
        }
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }
        // ensure the json data is a string
        if (data['notes'] && !(typeof data['notes'] === 'string' || data['notes'] instanceof String)) {
            throw new Error("Expected the field `notes` to be a primitive type in the JSON string but got " + data['notes']);
        }
        // ensure the json data is a string
        if (data['userId'] && !(typeof data['userId'] === 'string' || data['userId'] instanceof String)) {
            throw new Error("Expected the field `userId` to be a primitive type in the JSON string but got " + data['userId']);
        }

        return true;
    }


}

UserResponse.RequiredProperties = ["firstName", "lastName", "email", "phoneNumber", "address", "isAdmin", "enabled", "notes", "userId", "emailVerified", "timeCreated", "timeLastUpdated", "lastLogin"];

/**
 * @member {String} firstName
 */
UserResponse.prototype['firstName'] = undefined;

/**
 * @member {String} lastName
 */
UserResponse.prototype['lastName'] = undefined;

/**
 * @member {String} email
 */
UserResponse.prototype['email'] = undefined;

/**
 * @member {String} phoneNumber
 */
UserResponse.prototype['phoneNumber'] = undefined;

/**
 * @member {String} fireDeptId
 */
UserResponse.prototype['fireDeptId'] = undefined;

/**
 * @member {module:model/Address} address
 */
UserResponse.prototype['address'] = undefined;

/**
 * @member {Boolean} isAdmin
 */
UserResponse.prototype['isAdmin'] = undefined;

/**
 * @member {Boolean} enabled
 */
UserResponse.prototype['enabled'] = undefined;

/**
 * @member {String} notes
 */
UserResponse.prototype['notes'] = undefined;

/**
 * @member {String} userId
 */
UserResponse.prototype['userId'] = undefined;

/**
 * @member {Boolean} emailVerified
 */
UserResponse.prototype['emailVerified'] = undefined;

/**
 * @member {Date} timeCreated
 */
UserResponse.prototype['timeCreated'] = undefined;

/**
 * @member {Date} timeLastUpdated
 */
UserResponse.prototype['timeLastUpdated'] = undefined;

/**
 * @member {Date} lastLogin
 */
UserResponse.prototype['lastLogin'] = undefined;


// Implement UserBase interface:
/**
 * @member {String} firstName
 */
UserBase.prototype['firstName'] = undefined;
/**
 * @member {String} lastName
 */
UserBase.prototype['lastName'] = undefined;
/**
 * @member {String} email
 */
UserBase.prototype['email'] = undefined;
/**
 * @member {String} phoneNumber
 */
UserBase.prototype['phoneNumber'] = undefined;
/**
 * @member {String} fireDeptId
 */
UserBase.prototype['fireDeptId'] = undefined;
/**
 * @member {module:model/Address} address
 */
UserBase.prototype['address'] = undefined;
/**
 * @member {Boolean} isAdmin
 */
UserBase.prototype['isAdmin'] = undefined;
/**
 * @member {Boolean} enabled
 */
UserBase.prototype['enabled'] = undefined;
/**
 * @member {String} notes
 */
UserBase.prototype['notes'] = undefined;




export default UserResponse;

